import { WalletLink } from 'walletlink';
import { networks } from '../constants/networks';
import {getNetworkToSwitch, wait} from "./utils";

const options = {
  appName: 'Web3 Wallet Connector',
  appLogoUrl: 'https://uploads-ssl.webflow.com/6135af7e2959e2828758d352/6135e446c7842360045c0bd6_logo.svg',
  darkMode: true,
};

export const disconnectCoinbase = async () => {
  const walletLink = new WalletLink(options);
  walletLink.disconnect();
};

declare global {
  interface Window {
    disconnectCoinbase: () => void;
  }
}

window.disconnectCoinbase = disconnectCoinbase;

// TODO Add events
// https://github.com/walletlink/walletlink#use-eip-1102-to-obtain-authorization-and-get-ethereum-accounts

export const getCoinbaseProvider = async (networkId: number, rpcUrl: string) => {
  const walletLink = new WalletLink(options);

  const provider = walletLink.makeWeb3Provider(rpcUrl, networkId);
  await provider.enable();

  if (parseInt(provider.chainId, 16) !== networkId) {
    const network = getNetworkToSwitch(networkId);
    if (network) {
      const rpcUrls = [rpcUrl].concat(network.rpcUrls);
      const params = [{ ...network, rpcUrls }];
      try {
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{chainId: `0x${(networkId).toString(16)}`}]
        });

        return { provider };
      } catch (switchError) {
        const jsonRegexp = /("code"):[ ]?([-0-9]*)/gm;
        const errorCodes = JSON.stringify(switchError).match(jsonRegexp)?.map((match) => parseInt(match?.split(':')[1], 10));
        if (errorCodes?.includes(4902)) {
          try {
            await provider.request({ method: 'wallet_addEthereumChain', params });
            // To avoid Connection closed unexpectedly we need to wait 500ms
            await wait(500);
            return { provider };
          } catch (err) {
            throw new Error(`111 Your wallet network is not the same as in the app. Please, switch to the ${networks[networkId]?.chainName} network`);
          }
        }
      }
    }

    throw new Error(`222 Your wallet network is not the same as in the app. Please, switch to the ${networks[networkId]?.chainName} network`);
  }

  return { provider };
};
